import React from "react";
import {
  RotaTable,
  THead,
  TrHead,
  TBody,
  Th,
  Tr,
  Td,
  InnerCell,
  RotaButtonIcon,
  iconNew
} from "@teamrota/rota-design";

import { EmptyText } from "~/src/components/payroll/style";
import { PayrollBreak } from "./types";
import { formatDateFull } from "~/src/utils/formatting";

const { Edit, Info } = iconNew;

type TableProps = {
  payrollBreaks: PayrollBreak[];
  handleOpenBreak: (id: string) => void;
  canEdit: boolean;
};

const Table = ({ payrollBreaks, handleOpenBreak, canEdit }: TableProps) => {
  return (
    <RotaTable>
      <THead>
        <TrHead>
          <Th>Name</Th>
          <Th>User</Th>
          <Th>Created at</Th>
          <Th>Last edited</Th>
          <Th>Action</Th>
        </TrHead>
      </THead>

      <TBody>
        {payrollBreaks?.length ? (
          payrollBreaks.map((payrollBreak: PayrollBreak) => (
            <Tr key={payrollBreak.id}>
              <Td>
                <InnerCell>{payrollBreak.name}</InnerCell>
              </Td>
              <Td>
                <InnerCell>USER</InnerCell>
              </Td>
              <Td>
                <InnerCell>{formatDateFull(payrollBreak.createdAt)}</InnerCell>
              </Td>
              <Td>
                <InnerCell>
                  {payrollBreak.updatedAt &&
                    formatDateFull(payrollBreak.updatedAt)}
                </InnerCell>
              </Td>
              <Td>
                <InnerCell>
                  <RotaButtonIcon
                    onClick={() => handleOpenBreak(payrollBreak.id)}
                    style={{ margin: "auto" }}
                  >
                    {canEdit ? <Edit /> : <Info />}
                  </RotaButtonIcon>
                </InnerCell>
              </Td>
            </Tr>
          ))
        ) : (
          <Tr>
            <Td colSpan={5}>
              <EmptyText>Nothing to see here 👀 Try clicking Create!</EmptyText>
            </Td>
          </Tr>
        )}
      </TBody>
    </RotaTable>
  );
};

export default Table;
